// extracted by mini-css-extract-plugin
export default {"container":"KZzk2wT AAonn85 london2","totalQuantity":"XssXO17 EVhxZk8 leavesden2"};